import { getHasHateoasAccess } from 'helpers';
import { useGetCurrentBoard } from './useGetCurrentBoard';

/**
 * Whether the current board exposes queue groups at all. The `queueGroups` rel
 * maps to the board QueueGroupPolicy::list check (feature enabled + VIEW), so
 * this is a read/visibility signal — NOT a permission to create or edit groups.
 * Use it to gate showing the grouping UI, not to authorise write actions.
 *
 * Single source of truth, two scopes: this board-scoped hook and the
 * document-scoped `useDocumentCapability().queueGroups` are both gated by the
 * same `FeatureType::QueueGroups` on the organisation. Use the board-scoped hook
 * when there is no document in context (palette, default-queue, package
 * designers); use the document-scoped capability inside the document modal.
 */
export const useHasQueueGroupsAccess = () => {
  const { board } = useGetCurrentBoard();

  return getHasHateoasAccess('queueGroups', board?.__links);
};
